const InventoryIncomes = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryIncomes.vue");
const InventoryOutcomes = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryOutcomes.vue");
const InventoryIncomeEdit = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryIncomeEdit.vue");
const InventoryOutcomeEdit = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryOutcomeEdit.vue");
const InventoryTransfers = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryTransfers.vue");
const InventoryTransferEdit = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryTransferEdit.vue");
const InventoryTurnoverDetails = () =>
  import("@/modules/inventory/modules/inventoryTurnovers/views/InventoryTurnoverDetails.vue");

const incomeRoute = "/inventory/incomes";
const outcomeRoute = "/inventory/outcomes";
const transferRoute = "/inventory/transfers";

export default [
  {
    path: incomeRoute,
    name: "inventory.incomes.list",
    component: InventoryIncomes,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${incomeRoute}/create`,
    name: "inventory.incomes.create",
    component: InventoryIncomeEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${incomeRoute}/:inventoryTurnoverId`,
    name: "inventory.incomes.details",
    component: InventoryTurnoverDetails,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${incomeRoute}/:inventoryIncomeId/edit`,
    name: "inventory.incomes.edit",
    component: InventoryIncomeEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: outcomeRoute,
    name: "inventory.outcomes.list",
    component: InventoryOutcomes,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${outcomeRoute}/create`,
    name: "inventory.outcomes.create",
    component: InventoryOutcomeEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${outcomeRoute}/:inventoryTurnoverId`,
    name: "inventory.outcomes.details",
    component: InventoryTurnoverDetails,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${outcomeRoute}/:inventoryOutcomeId/edit`,
    name: "inventory.outcomes.edit",
    component: InventoryOutcomeEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: transferRoute,
    name: "inventory.transfers.list",
    component: InventoryTransfers,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${transferRoute}/create`,
    name: "inventory.transfers.create",
    component: InventoryTransferEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${transferRoute}/:inventoryTurnoverId`,
    name: "inventory.transfers.details",
    component: InventoryTurnoverDetails,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${transferRoute}/:inventoryTransferId/edit`,
    name: "inventory.transfers.edit",
    component: InventoryTransferEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
